const storageKey = 'motionlab:booking-return'

/** Only allow course-session routes generated by the booking dialogs. */
export function validBookingReturnPath(path: string | null): string | null {
  return path && /^\/kurse\/[a-f0-9-]{36}\/termine\/[a-f0-9-]{36}$/i.test(path) ? path : null
}

export function readBookingReturnPath(params: URLSearchParams): string | null {
  const path = validBookingReturnPath(params.get('zurueck'))
  if (path) return path
  if (!params.has('checkout')) return null
  try {
    return validBookingReturnPath(sessionStorage.getItem(storageKey))
  } catch {
    return null
  }
}

export function rememberBookingReturnPath(path: string | null): void {
  try {
    if (path) sessionStorage.setItem(storageKey, path)
    else sessionStorage.removeItem(storageKey)
  } catch {
    // Buying credits still works when browser storage is unavailable.
  }
}
